import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import { Card, CardHeader, CardContent, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";

import workareas from "config/workareas";

import MapButton from "./MapButton";

const WorkareaLayout = props => {
  const columnSizes = (noWorkareas, min) => Math.max(12 / noWorkareas, min);
  return (
    <Row>
      <Col xs={12}>
        <Card>
          <CardHeader
            title="Select a workarea"
            style={{ textAlign: "center" }}
          />
          <CardContent>
            <Row
              style={{
                display: "flex",
                gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))"
              }}
            >
              {props.allowedWorkareas && props.allowedWorkareas.length ? (
                workareas
                  .filter(workarea =>
                    props.allowedWorkareas.includes(workarea.name.toUpperCase())
                  )
                  .map(workarea => {
                    return (
                      <Col
                        style={{
                          boxShadow: "rgba(0, 0, 0, 0.56) 0px 22px 70px 4px",
                          minWidth: "320px",
                          flexBasis: "15%",
                          height: "auto",
                          borderRadius: "15%",
                          width: "100%",
                          margin: " 30px 45px",
                          hover: { border: "1px" }
                        }}
                        key={workarea.name}
                        xs={columnSizes(props.allowedWorkareas.length, 12)}
                        md={columnSizes(props.allowedWorkareas.length, 6)}
                        lg={columnSizes(props.allowedWorkareas.length, 4)}
                        xl={columnSizes(props.allowedWorkareas.length, 3)}
                      >
                        <MapButton
                          onClick={() => props.onSelectWorkarea(workarea.name)}
                          label={workarea.label}
                          img={workarea.img}
                        />
                      </Col>
                    );
                  })
              ) : (
                <Typography style={{ textAlign: "center", margin: "5px" }}>
                  <WarningIcon />
                  <b>
                    You need access to workareas to be able to use this page.
                    Please contact eims.support@hakai.org to request access.
                  </b>
                </Typography>
              )}
            </Row>
          </CardContent>
        </Card>
      </Col>
    </Row>
  );
};

WorkareaLayout.propTypes = {
  onSelectWorkarea: PropTypes.func.isRequired,
  allowedWorkareas: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default WorkareaLayout;
